<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="16">
      <el-select v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 20px">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="keyword" style="width: 200px" placeholder="輸入查詢關鍵字" class="ml-10"
                suffix-icon="el-icon-search"></el-input>

      <el-button type="primary" @click.prevent="search" class="ml-10">查詢</el-button>
      <el-button type="normal" @click.prevent="clearQuery" class="ml-10">清除條件</el-button>
    </el-col>

    <el-col :xs="24" :sm="24" :lg="8" style="text-align: right">
      <!--        <el-button type="primary" @click.prevent="exportData" >匯出 <i class="el-icon-upload2"></i></el-button>-->
      <el-button type="primary" @click.prevent="handleAdd" class="mr-20">新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-col :xs="24" :sm="24" :lg="6">
        <el-main>
          <el-table :data="groupByTableData"
                    default-expand-all
                    row-key="id"
                    empty-text="無資料"
                    stripe header-row-class-name="headerStyle">
            <el-table-column label="分區">
              <template slot-scope="scope">
               
                <el-button type="text" @click.prevent="searchTerm(scope.row.col)"> {{scope.row.col}} ({{scope.row.count}})</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-col>

      <el-col :xs="24" :sm="24" :lg="18">
      <el-main>
          <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
            <el-table-column prop="username" label="姓名" width="160">
              <template slot-scope="scope">
                <img v-if="scope.row.avatar" :src="displayAvatar(scope.row.avatar)" class="display-avatar">
                {{scope.row.username}}
              </template>
            </el-table-column>
            <el-table-column prop="empno" label="工號" width="140">
            </el-table-column>
            <el-table-column prop="phone" label="電話">
            </el-table-column>
            <el-table-column prop="role.name" label="角色">
            </el-table-column>
            <el-table-column label="操作" width="400">
              <template slot-scope="scope">
                <el-button type="warning" @click="handleEdit(scope.row)">編輯 <i class="el-icon-edit"></i></el-button>
                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="確定刪除此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消刪除"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleDelete(scope.row.id)"
                >
                  <el-button type="danger" slot="reference">刪除 <i class="el-icon-delete"></i></el-button>
                </el-popconfirm>
                <el-button class="ml-10" v-if="scope.row.role.name.indexOf('業務') != -1" type="primary"
                           @click="setupCustomers(scope.row)">設定負責客戶 <i class="el-icon-edit"></i></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>

        </el-main>
      </el-col>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="帳號資訊"
               :visible.sync="dialogFormVisible"
               :width="dw"
               @close="closeDialog">
      <el-form :model="form" label-position="top" :rules="rules" ref="userForm" label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-upload
                drag
                :multiple="false"
                class="avatar-uploader"
                action="/api/file/upload"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="form.avatar" :src="displayAvatar(form.avatar)" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">限上傳 jpg、png 格式，且大小不超過 2M</div>
              <div slot="tip" class="el-upload__tip">(建議圖片長寬以1:1的比例最適合)</div>
            </el-upload>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" class="pr-10">
            <el-form-item label="工號" prop="empno">
              <el-input v-model="form.empno" autocomplete="off" @focusout="checkExist"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="姓名" prop="username" :label-width="formLabelWidth">
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" class="pr-10">
            <el-form-item label="聯絡電話" prop="phone" :label-width="formLabelWidth">
              <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="登入密碼" prop="password" :label-width="formLabelWidth">
              <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8">
            <el-form-item label="角色" :label-width="formLabelWidth">
              <el-select v-model="form.roleId" placeholder="選擇所屬角色">
                <el-option v-for="role in roles"
                           :key="role.id"
                           :label="role.name"
                           :value="role.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8">
            <el-form-item label="所在區域" :label-width="formLabelWidth">
              <el-select v-model="form.area" placeholder="選擇所在區域">
                <el-option label="北區" value="北區"></el-option>
                <el-option label="中區" value="中區"></el-option>
                <el-option label="南區" value="南區"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8">
            <el-form-item label="有刪除客戶資料的權限">
              <el-select v-model="form.deletePermission"  placeholder="請選擇" >

                <el-option v-for="(p,idx) in permissionList"
                           :key="idx"
                           :label="p.label"
                           :value="p.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData('userForm')">確 定</el-button>
      </div>
    </el-dialog>
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  name: "UserMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      console.log('checkName:', value)
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      dw: '50%',
      tableData: [],
      options: [
        {value: 'username', label: '依姓名' }, 
        {value: 'phone', label: '依電話'},
        {value: 'area', label: '分區'}
        ],
      permissionList: [{
        value: 0,
        label: '否'
      }, {
        value: 1,
        label: '是'
      }],
      
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 20,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      form: {
        empno: '',
        roleId: '',
        username: '',
        password: '',
        phone: '',
        avatar: '',
        checked1:true
      },
      groupByTableData:[],
      roles: [],
      rules: {
        empno: [{validator: checkName, trigger: 'change'}],
        username: [{validator: checkName, trigger: 'change'}],
        phone: [{validator: checkName, trigger: 'change'}],
        password: [
          {validator: checkName, trigger: 'change'},
          {min: 6, max: 8, message: '密碼 6~8 碼之間', trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    searchTerm(term){
      this.queryField = 'area'
      this.keyword = term
      this.loadData()
    },
    setupCustomers(row) {
      this.$router.push('/users/set-customer/' + row.id)
    },
    search() {
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    clearQuery() {
      this.keyword = ''
      this.queryField = ''
      this.loadData()
    },

    /** data crud **/
    async loadData() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        queryField: this.queryField,
        keyword: this.keyword
      }
      try {
        let result = await this.$store.dispatch('user/getAllUsers', data);
        this.tableData = result.data.records
        this.total = result.data.total
      } catch (e) {
        this.tableData = []
        this.total = 0
        this.showResult('error', e.message)
      }

    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log("valid:", valid)
        if (valid) {
          try {
            await this.$store.dispatch('user/saveUser', this.form)
            this.showResult('success', '資料更新成功.')

            await this.loadData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.loadRole()
      this.form.empno = ''
      this.form.roleId = ''
      this.form.username = ''
      this.form.password = ''
      this.form.phone = ''
      this.form.avata = ''
    },
    async loadRole() {
      if (this.roles.length === 0) {
        const result = await this.$store.dispatch('role/getAllRolesNoPage')
        this.roles = result.data
      }
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    async handleDelete(id) {
      try {
        console.log('delete:', id)
        await this.$store.dispatch('user/deleteUser', id)
        this.showResult('success', '資料刪除成功.')

        await this.loadData()
        this.dialogFormVisible = false

      } catch (e) {
        this.showResult('error', '資料刪除失敗.')
      }
    },

    closeDialog() {
      this.$refs['userForm'].resetFields()
      this.form.avatar = ''
      this.loadData()
    },
    handleAvatarSuccess(res, file) {
      this.form.avatar = res.uuid
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('限上傳 jpg、png 格式');
      }
      if (!isLt2M) {
        this.$message.error('圖片大小超過 2M');
      }
      return isJPG && isLt2M;
    },
    checkExist() {

    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "50%";
      }
    },

    loadGroupbyData() {
      this.request.get("/user/groupby").then(res => {
        if (res.code === '200') {
          this.groupByTableData = res.data
        }
      })
    }

  },
  mounted() {
    this.loadData()
    this.loadRole()
    this.setDialogWidth()
    this.loadGroupbyData()

  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
